// /components/SearchFilterBar.js
import React from "react";

const SearchFilterBar = ({
  searchQuery,
  setSearchQuery,
  showStarredOnly,
  setShowStarredOnly
}) => (
  <div className="search-container">
    <input
      type="text"
      placeholder="Search recordings..."
      value={searchQuery}
      onChange={e => setSearchQuery(e.target.value)}
      className="search-input"
    />
    <span className="search-divider" aria-hidden="true">|</span>
    <label className="starred-filter-label">
      <input
        type="checkbox"
        checked={showStarredOnly}
        onChange={e => setShowStarredOnly(e.target.checked)}
        aria-label="Show only starred recordings"
      />
      <span className="star-icon" aria-label="star" role="img">★</span>
      Show only starred
    </label>
  </div>
);

export default SearchFilterBar;
